module.exports = __webpack_public_path__ + "static/media/22.9d777b4f.wav";